export default "__VITE_ASSET__D_h5jBly__"